import React, { useState, useEffect, useRef } from "react";
import "swiper/css";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import DropdownTest from "../Create-Investment/ndrop";
import { format, parse } from "date-fns";
import { useToast } from "../../Utils/toastContext";
import { changeAdvisorTabFalse } from "../../Redux/store/selectedCard";
import { useSelector, useDispatch } from "react-redux";
import { clearAdvisorName } from "../../Redux/store/userSlice";
import countriesData from "../../Data/CountryCodes.json";
import AddUserPopup from "../Create-Investment/Add-User-Popup";

const validator = require("validator");

const AdvisorList = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showRecords, setShowRecords] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [totalCount, settotalCount] = useState(0);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSendMessageOpen, setIsSendMessageOpen] = useState(false);
  const [istemplateOpen, setIstemplateOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [isNewChange, setisNewChange] = useState(true);
  const [startAmount, setStartAmount] = useState(0);
  const [endAmount, setEndAmount] = useState(0);
  const [isToUser, setToUser] = useState(false);
  const [isFileExisted, setIsFileExisted] = useState(false);
  const [file, setFile] = useState(null);
  const [newFile, setnewFile] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [currentDoc, setCurrentDoc] = useState(null);
  const [isDocDelete, setIsDocDelete] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef();
  const buttonRefs = useRef({});
  const [pendingFilter, setPendingFilter] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [customerFirstName, setCustomerFirstName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [customerLastName, setCustomerLastName] = useState("");
  const [email, setEmail] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [comments, setComments] = useState("");
  const [focus, setFocus] = useState(false);
  const [countries, setCountries] = useState([]);
  const [isOpenNewCustomer, setIsOpenNewCustomer] = useState(false);
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [isOpenAddCustomer, setIsOpenAddCustomer] = useState(false);
  const [advisorID, setAdvisorID] = useState(null);
  const addCustomerRef = useRef();

  const CUSTOMER_TYPES = [
    { value: 1, label: "Individual" },
    { value: 2, label: "Corporate" },
    { value: 3, label: "Trust" },
    { value: 4, label: "Agents" },
    { value: 5, label: "Association" },
    { value: 6, label: "Government Bodies" },
    { value: 7, label: "Partnership" },
    { value: 8, label: "Registered Co-Operative" },
    { value: 9, label: "Politically Exposed Persons" },
  ];
  const optionsForCustomers = [
    { value: "new", label: "New Advisor" },
    { value: "existing", label: "Existing Advisor" },
  ];
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const handleAddCustomer = (e, option) => {
    if (option.value == "existing") {
      setisUserPopOpen(true);
    }
    if (option.value == "new") {
      togglePopupAddCustomer();
    }
  };
  const handlePendingClick = () => {
    //  setFilter("to_review");
    setIsDropdownOpen((prevState) => !prevState); // Toggle dropdown
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.name.endsWith(".docx")) {
      setSelectedFile(file);
      setPopupOpen(true);
    } else {
      alert("Please upload a valid .docx file.");
    }
  };
  const clearAllCustomerFields = () => {
    setCustomerFirstName("");
    setSelectedCode("");
    setMobileNumber("");
    setAdvisorID(null);
    setCustomerLastName("");
    setEmail("");
    setCustomerType("");
    setComments("");
  };
  const handleSelectCustomerType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setCustomerType(selectedOption.value);
  };
  const togglePopupAddCustomer = () => {
    clearAllCustomerFields();
    setIsOpenNewCustomer(!isOpenNewCustomer);
  };
  const handleFileChange = (e) => {
    if (file) {
      setIsFileExisted(true);
      setCurrentFile(e.target.files[0]);
      return;
    } else {
      setnewFile(e.target.files[0]);
    }
  };
  useEffect(() => {
    updateFile();
  }, [newFile]);
  const updateFile = () => {
    const selectedFile = newFile;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        [
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFile(selectedFile);
      } else {
        showToast(
          "File must be doc or docx format and must be less than 10MB",
          "error"
        );

        setIsFileExisted(false);
      }
    }
  };
  const documents = [
    {
      id: 1,
      name: "test Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 2,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 3,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 4,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 5,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 6,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 7,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 8,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 9,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    {
      id: 10,
      name: "Customer Signature.doc",
      date: "22-01-2024 | 4.56 PM",
      size: "122.4 KB",
      icon: "/word-icon.svg",
    },
    // Add more documents as needed
  ];

  const togglePopup = () => setIsOpen(!isOpen);
  const toggleSendMessagePopup = () => setIsSendMessageOpen(!isSendMessageOpen);
  const toggleAddTemplatePopup = () => {
    setIstemplateOpen(!istemplateOpen);
  };

  const [from, setFrom] = useState("John Mayer");
  const [recipients, setRecipients] = useState([
    "Jason Quest",
    "Brian Vaughan",
  ]);
  const [suggestions] = useState([
    "Brian Vaughan",
    "Brian Edmon",
    "Colin Simpson",
  ]);
  const [inputValue, setInputValue] = useState(""); // Track the input value

  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const [filteredSuggestions, setFilteredSuggestions] = useState(suggestions); // Store filtered suggestions
  const [showSuggestions, setShowSuggestions] = useState(false); // Control dropdown visibility

  const handleAddRecipient = (recipient) => {
    setRecipients([...recipients, recipient]);
    setInputValue(""); // Clear the input field
    setShowSuggestions(false); // Hide the dropdown after selection
  };

  const handleRemoveRecipient = (index) => {
    const updatedRecipients = [...recipients];
    updatedRecipients.splice(index, 1);
    setRecipients(updatedRecipients);
  };
  const handleScroll = (indexToRemove) => {
    setIsDropdownOpen(false);
  };
  const handleInputChangeAddRecipient = (e) => {
    const value = e.target.value;
    setInputValue(value);
    // Filter suggestions based on the input value
    const filtered = suggestions.filter((suggestion) =>
      suggestion.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSuggestions(filtered);
    setShowSuggestions(value.trim().length > 0);
  };
  const [selectedOption, setSelectedOption] = useState(null); // State to hold selected option

  const fromOptions = [
    {
      value: "1",
      label: "John Doe",
      role: "Developer",
      image: "/avatar.svg",
    },
    {
      value: "2",
      label: "Jane Smith",
      role: "Designer",
      image: "/avatar.svg",
    },
    {
      value: "3",
      label: "Mike Lee",
      role: "Project Manager",
      image: "/avatar.svg",
    },
  ];
  const handleAddRecipientButton = () => {
    if (filteredSuggestions.includes(inputValue.trim())) {
      handleAddRecipient(inputValue.trim());
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [preSelectedFromFilter, setPreSelectedFromFilter] = useState({
    value: 1,
    label: "Anfas",
  });
  const handleFromFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setPreSelectedFromFilter(selectedOption);
  };
  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedCustomers([]); // Deselect all
    } else {
      setSelectedCustomers(customers.map((customer) => customer.id)); // Select all
    }
    setSelectAll(!selectAll); // Toggle Select All state
  };
  const removeUsers = async (e) => {
    e.preventDefault();
    try {
      const response = await DeleteUser();
      if (response.status == 200) {
        getCustomers();
        setSelectedCustomers([]);
        setSelectAll(false);
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const DeleteUser = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/delete`;
    const bodyData = {
      user_ids: selectedCustomers,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleDeleteFile = () => {
    setFile(null);
  };
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setpreSelectedFilter(selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const toggleTableSelection = (customerId) => {
    setSelectedCustomers(
      (prevSelected) =>
        prevSelected.includes(customerId)
          ? prevSelected.filter((id) => id !== customerId) // Remove if already selected
          : [...prevSelected, customerId] // Add if not selected
    );
  };
  const headers = [
    { label: "Name", key: "first_name" },
    { label: "Email", key: "email_address" },
    { label: "Status", key: "status" },
    { label: "Client No", key: "client_id" },
    { label: "Type", key: "type" },
    { label: "Accounts", key: "cash_accounts" },
    { label: "Portfolio", key: "portfolio" },
    { label: "Credit", key: "credit" },
    { label: "Location", key: "location" }, // No sorting for actions
    { label: "Date & Time", key: "created_at" }, // No sorting for actions
  ];
  const reviewHeaders = [
    { label: "Name", key: "first_name" },
    { label: "Client No", key: "client_id" },
    { label: "Type", key: "type" },
    { label: "Accounts", key: "cash_accounts" },
    { label: "Portfolio", key: "portfolio" },
    { label: "Cash", key: "credit" },
    { label: "Location", key: "location" }, // No sorting for actions
    { label: "Date & Time", key: "created_at" }, // No sorting for actions
  ];
  const handleBlur = () => {};
  const cardData = [
    {
      label: "Total Cash Account",
      amount: "4,530.00",
      accounts: 2,
      lessColor: "bg-[#5D88F8] bg-opacity-40",
      tail: "border-t-[#5D88F8]  border-opacity-70",

      color: "bg-[#5D88F8] bg-opacity-70",
    },
    {
      label: "Total Fund Managment",
      amount: "750.00",
      accounts: 1,
      color: "bg-[#996EE7] bg-opacity-70",
      lessColor: "bg-[#996EE7] bg-opacity-40",
      tail: "border-t-[#996EE7] border-opacity-70",
    },
    {
      label: "Total Securities",
      amount: "3,910.00",
      accounts: 1,
      color: "bg-[#F18C29] bg-opacity-70",
      lessColor: "bg-[#F18C29] bg-opacity-40",
      tail: "border-t-[#F18C29] border-opacity-70",
    },
    {
      label: "Total Trading",
      amount: "13,157,750.00",
      accounts: 2,
      color: "bg-[#DC4646] bg-opacity-70",
      lessColor: "bg-[#DC4646] bg-opacity-40",
      tail: "border-t-[#DC4646] border-opacity-70",
    },
    {
      label: "Total Custodian",
      amount: "0.00",
      accounts: 0,
      color: "bg-[#2DB0EC] bg-opacity-70",
      lessColor: "bg-[#2DB0EC] bg-opacity-40",
      tail: "border-t-[#2DB0EC] border-opacity-70",
    },
  ];
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  function formatDateTime(inputDateStr) {
    const date = new Date(inputDateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const yyyy = date.getFullYear();

    const HH = String(date.getHours()).padStart(2, "0");
    const MM = String(date.getMinutes()).padStart(2, "0");
    const SS = String(date.getSeconds()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy} | ${HH}:${MM}:${SS}`;
  }
  // const formatDateTime = (dateTimeStr) => {
  //   const date = new Date(dateTimeStr);

  //   const pad = (num) => String(num).padStart(2, "0");

  //   const day = pad(date.getDate());
  //   const month = pad(date.getMonth() + 1); // Months are zero-based
  //   const year = date.getFullYear();

  //   const hours = pad(date.getHours());
  //   const minutes = pad(date.getMinutes());
  //   const seconds = pad(date.getSeconds());

  //   return (
  //     <>
  //       {`${day}/${month}/${year}`}
  //       <br />
  //       {`${hours}:${minutes}:${seconds}`}
  //     </>
  //   );
  // };
  const handleSort = (key) => {
    setFilterText(key);
  };
  const formatNumber = (value) => {
    // Format number with commas and two decimal places
    return Number(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );

      if (isOutside) {
        setIsDropdownOpen(false); // Close dropdown if clicked outside
      }
      if (
        addCustomerRef.current &&
        !addCustomerRef.current.contains(event.target)
      ) {
        setIsOpenAddCustomer(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const unformatNumber = (value) => {
    // Remove commas from the formatted number
    return value.replace(/,/g, "");
  };

  const handleInputChange = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setStartAmount(numericValue); // Save the unformatted value
    }
    // if (numericValue > 0) {
    //   setportfolioDataAvailable(false);
    // }
  };
  const handleInputChangeEndAmount = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setEndAmount(numericValue); // Save the unformatted value
    }
    // if (numericValue > 0) {
    //   setportfolioDataAvailable(false);
    // }
  };

  const getCustomers = async () => {
    setIsLoading(true);
    const direction = sortConfig.direction === "asc" ? "desc" : "asc";

    try {
      const response = await GetAPIcalls(
        filter == ""
          ? `/v1/dashboard/all-advisors?search=${searchQuery}&page=${currentPage}&size=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
          : `/v1/dashboard/all-advisors?search=${searchQuery}&page=${currentPage}&size=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`
      );

      if (response.status == 200) {
        setCustomers(response.data.users);
        settotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
        setSortConfig({ key: null, direction });
      }, 100);
    }
  };
  const handleSelectInvestmentManagerAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
  };
  useEffect(() => {
    getCustomers();
  }, [searchQuery, currentPage, showRecords, filter, filterText]);
  useEffect(() => {
    dispatch(changeAdvisorTabFalse());
  }, []);
  return (
    <div className="pt-4 p-2">
      {/* Summary Cards */}
      {/* add if required in future */}
      {/* <CustomCardSlider componentName="customer" cardData={cardData} /> */}
      <div
        onScroll={handleScroll}
        className="pt-4  text-xs overflow-x-auto  flex-wrap items-center"
      >
        <div className="flex mb-2 ">
          <button
            onClick={() => setFilter("")}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === "" ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            All
          </button>
          <button
            onClick={() => setFilter("active")}
            className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
              filter === "active"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Active
          </button>
          <button
            onClick={() => setFilter("onboarding")}
            className={`px-4 py-2  ${
              filter === "onboarding"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Onboarding
          </button>
          <div className="relative">
            <button
              onClick={handlePendingClick}
              ref={(el) => (buttonRefs.current[`pending`] = el)}
              className={`flex items-center px-4 py-2 border-r border-gray-100 ${
                filter === "to_review" ||
                filter === "in_progress" ||
                filter === "sent_for_resubmit" ||
                filter === "sent_for_approval"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Pending
              <img
                src="/Polygon-2.svg"
                alt="Dropdown Icon"
                className="ml-2 w-2 h-2"
              />
            </button>
            <DropdownTest
              isOpen={isDropdownOpen}
              buttonRef={buttonRefs.current[`pending`]} // Pass unique ref to the dropdown
            >
              <div className="absolute mt-2 text-sm bg-white border border-gray-200 rounded-md shadow-lg w-40">
                <ul className="text-left">
                  <li
                    onClick={() => {
                      setFilter("to_review");
                      setIsDropdownOpen(false);
                    }}
                    className={`px-4 py-2 hover:bg-black hover:text-white cursor-pointer ${
                      filter === "to_review"
                        ? "bg-black text-white"
                        : "bg-white text-black"
                    }`}
                  >
                    To Review
                  </li>
                  <li
                    onClick={() => {
                      setFilter("in_progress");
                      setIsDropdownOpen(false);
                    }}
                    className={`px-4 py-2 hover:bg-black hover:text-white cursor-pointer ${
                      filter === "in_progress"
                        ? "bg-black text-white"
                        : "bg-white text-black"
                    }`}
                  >
                    In Progress
                  </li>
                  <li
                    onClick={() => {
                      setFilter("sent_for_resubmit");
                      setIsDropdownOpen(false);
                    }}
                    className={`px-4 py-2 hover:bg-black hover:text-white cursor-pointer ${
                      filter === "sent_for_resubmit"
                        ? "bg-black text-white"
                        : "bg-white text-black"
                    }`}
                  >
                    Sent for Resubmit
                  </li>
                  <li
                    onClick={() => {
                      setFilter("sent_for_approval");
                      setIsDropdownOpen(false);
                    }}
                    className={`px-4 py-2 hover:bg-black hover:text-white cursor-pointer ${
                      filter === "sent_for_approval"
                        ? "bg-black text-white"
                        : "bg-white text-black"
                    }`}
                  >
                    Sent for Approval
                  </li>
                </ul>
              </div>
            </DropdownTest>
          </div>
          <button
            onClick={() => setFilter("resubmit")}
            className={`px-4 py-2 border-r border-gray-100 ${
              filter === "resubmit"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Resubmit
          </button>{" "}
          <button
            onClick={() => setFilter("suspended")}
            className={`px-4 py-2 border-r border-gray-100 ${
              filter === "suspended"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Suspended
          </button>{" "}
          <button
            onClick={() => setFilter("archieved")}
            className={`px-4 py-2 rounded-r-xl ${
              filter === "archieved"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Archive
          </button>
        </div>
      </div>
      {filter != "to_review" && (
        <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/customer-black.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Advisor List
              </span>
            </div>
            <div ref={addCustomerRef} className="flex items-center space-x-4">
              <div className="relative inline-block ">
                <div
                  className="flex items-center justify-center gap-2 px-4 py-2 border border-[#005A9C] text-[#005A9C] rounded-xl cursor-pointer h-11 w-auto"
                  onClick={() => setIsOpenAddCustomer(!isOpenAddCustomer)}
                >
                  <img
                    src="/Plus.svg"
                    alt="document-download"
                    className="mr-2"
                  />
                  <span>Add Advisor</span>
                </div>
                {isOpenAddCustomer && (
                  <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                    {optionsForCustomers.map((option) => (
                      <li
                        key={option.value}
                        className="flex items-center p-2 hover:bg-[#005A9C] hover:text-white cursor-pointer"
                        onClick={(e) => {
                          e.preventDefault();
                          handleAddCustomer(e, option);
                        }}
                      >
                        {option.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
          {isUserPopOpen && (
            <AddUserPopup
              componentName="advisorList"
              onClose={() => setisUserPopOpen(false)}
            />
          )}
          {isOpenNewCustomer && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-medium text-center w-full">
                      Add New Advisor
                    </h2>
                    <div className="flex justify-end">
                      <img
                        onClick={togglePopupAddCustomer}
                        src="/add.svg"
                        alt="Add"
                        className="w-10 h-10 cursor-pointer"
                      />
                    </div>
                  </div>
                  <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4 pt-4 px-4">
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          First Name
                        </label>{" "}
                        <input
                          id="finInstituition"
                          type="text"
                          value={customerFirstName}
                          onChange={(e) => setCustomerFirstName(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Doe"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Mobile Number
                        </label>{" "}
                        <div className="flex  items-center">
                          <select
                            value={selectedCode}
                            onChange={handleCodeChange}
                            onFocus={() => setFocus(true)}
                            onBlur={() => setFocus(false)}
                            className={`w-40 border text-code text-sm font-medium rounded-tl-md rounded-tr-none rounded-br-none rounded-bl-md h-[2.813rem]  ${
                              focus
                                ? "border-black border-2"
                                : " border-gray-300 "
                            } border-r-0   border  py-2 px-1 leading-tight focus:outline-none `}
                            placeholder="AU+61"
                          >
                            {countries.map((country) => (
                              <option
                                key={country.code}
                                value={country.dialCode}
                              >
                                {country.code} {country.dialCode}
                              </option>
                            ))}
                          </select>
                          <input
                            type="tel"
                            id="mobileNumber"
                            value={mobileNumber}
                            onFocus={() => setFocus(true)}
                            onBlur={() => setFocus(false)}
                            onChange={(e) => setMobileNumber(e.target.value)}
                            placeholder="Mobile Number"
                            className={`border text-black text-base font-medium rounded-tr-md rounded-tl-none rounded-bl-none rounded-br-md h-[2.813rem] p-2 ${
                              focus
                                ? "border-black border-2"
                                : " border-gray-300 "
                            } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Center Column with Border */}
                    <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Last Name
                        </label>{" "}
                        <input
                          id="finInstituition"
                          type="text"
                          value={customerLastName}
                          onChange={(e) => setCustomerLastName(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Doe"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Email
                        </label>{" "}
                        <input
                          id="finInstituition"
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Doe"
                        />
                      </div>
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4 px-4 pt-4">
                      <div className="">
                        <Dropdown
                          label="Select Customer Type"
                          options={CUSTOMER_TYPES}
                          onSelect={handleSelectCustomerType}
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Comments
                        </label>{" "}
                        <textarea
                          type="text"
                          name="documentId"
                          value={comments}
                          maxLength={18}
                          onChange={(e) => setComments(e.target.value)}
                          className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                          placeholder="Add your comments"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                    <button
                      onClick={togglePopupAddCustomer}
                      className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();

                        if (!customerType) {
                          showToast("Please select customer type", "error");
                          return;
                        }
                        if (!validateEmail(email)) {
                          showToast("Please enter iban", "error");
                          return;
                        }
                        if (!customerLastName) {
                          showToast("Please enter last name", "error");
                          return;
                        }
                        if (
                          !validator.isMobilePhone(
                            selectedCode + mobileNumber,
                            "any"
                          )
                        ) {
                          showToast(
                            "Please enter valid mobile number",
                            "error"
                          );
                          return;
                        }
                        if (!customerFirstName) {
                          showToast("Please enter first name", "error");
                          return;
                        }

                        //  setLoading(true);
                        // handleAddBank(e);
                      }}
                      className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                    >
                      Add Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-6 text-sm border rounded-xl"
                    placeholder="Search Advisor"
                    value={searchQuery}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {" "}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-4 items-center">
              {/* Filter Button */}
              <div className="w-full sm:w-auto">
                <button
                  onClick={togglePopup}
                  className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                >
                  <div className="flex items-center">
                    <img
                      src="/filter-sort-black.svg"
                      alt="Filter Icon"
                      className="h-5 w-5 mr-2"
                    />
                    Filter
                  </div>
                </button>
              </div>

              {/* Modal Popup */}
              {isOpen && (
                <div className="fixed inset-0 w-full flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
                  <div className="bg-white rounded-lg w-[90%] md:w-[60%] max-w-[500px] p-6 max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Filters
                      </h2>
                      <button onClick={togglePopup}>
                        <img
                          src="/add.svg"
                          alt="Close"
                          className="w-8 h-8 md:w-10 md:h-10"
                        />
                      </button>
                    </div>

                    {/* Modal Content */}
                    <div className="grid grid-cols-1 gap-4">
                      <Dropdown
                        label="Applicant's Location"
                        options={users}
                        onSelect={handleSelectInvestmentManagerAccount}
                      />
                      <Dropdown
                        label="Default Currency"
                        options={users}
                        onSelect={handleSelectInvestmentManagerAccount}
                      />
                      <Dropdown
                        label="Risk of Location"
                        options={users}
                        onSelect={handleSelectInvestmentManagerAccount}
                      />

                      <div className="flex flex-wrap md:flex-nowrap md:gap-4 gap-0 items-center">
                        {/* First Cash Amount Input */}
                        <div className="flex-1 min-w-[40%]">
                          <label className="block text-sm text-[#464646] mb-1">
                            Cash Amount
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              value={
                                startAmount ? formatNumber(startAmount) : ""
                              }
                              onChange={handleInputChange}
                              className="block p-2 w-full text-black font-medium border border-gray-300 rounded-md text-sm"
                            />
                            <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                              AU$
                            </span>
                          </div>
                        </div>

                        {/* 'to' Label */}
                        <div className="w-full md:w-auto text-center mt-4 md:text-left">
                          <span className="block md:inline text-sm text-black  md:mt-4">
                            to
                          </span>
                        </div>

                        {/* Second Cash Amount Input */}
                        <div className="flex-1 min-w-[40%]">
                          <label className="block text-sm text-[#464646] mb-1 invisible">
                            Hidden Label
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              value={endAmount ? formatNumber(endAmount) : ""}
                              onChange={handleInputChangeEndAmount}
                              className="block p-2 w-full text-black font-medium border border-gray-300 rounded-md text-sm"
                            />
                            <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                              AU$
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex flex-col md:flex-row justify-center md:space-x-4 space-y-2 md:space-y-0 mt-6">
                      <button
                        onClick={togglePopup}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        className={`px-6 py-2 rounded-lg ${
                          isNewChange
                            ? "bg-gray-400"
                            : "bg-black text-white hover:bg-gray-800"
                        }`}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Send Message Button */}
              <div className="w-full sm:w-auto">
                <button
                  disabled={true}
                  onClick={toggleSendMessagePopup}
                  className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                >
                  <div className="flex items-center">
                    <img
                      src="/send-message.svg"
                      alt="Send Message Icon"
                      className="h-5 w-5 mr-2"
                    />
                    Send Message
                  </div>
                </button>
              </div>
              {isSendMessageOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="w-[90%] md:w-[50%] max-w-[700px] bg-[#F9F9F9] rounded-lg p-6 shadow-lg max-h-[90%] overflow-y-auto">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg text-center w-full font-semibold">
                        New Message
                      </h2>
                      <button onClick={toggleSendMessagePopup}>
                        <img src="/add.svg" alt="Close" className="w-10 h-10" />
                      </button>
                    </div>

                    <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
                      {" "}
                      <div className="flex items-center mb-4 w-full w-full">
                        <label className="w-1/4 text-sm font-medium text-labelLightColour">
                          From:
                        </label>
                        <div className="w-3/4">
                          <div className="relative w-full md:w-full">
                            {/* Dropdown Button */}
                            <button
                              onClick={() => setToUser(!isToUser)}
                              className="w-full md:w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-2 py-2 pr-10 flex justify-between items-center focus:outline-none bg-white text-black"
                            >
                              <div className="flex items-center flex-grow">
                                {/* Selected Image */}
                                <img
                                  src={selectedOption?.image || "/avatar.svg"} // Display image from selected option or default image
                                  alt="User Icon"
                                  className="h-5 w-5 mr-2"
                                />
                                {/* Display selected name and role */}
                                <div className="flex flex-col  md:flex-row truncate">
                                  {selectedOption ? (
                                    <>
                                      <span className="mr-2 truncate">
                                        {selectedOption.label}
                                      </span>
                                      <span className="text-[#005A9C] truncate">
                                        {selectedOption.role}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <span className="truncate">
                                        name here
                                      </span>
                                      <span className="text-[#005A9C] ml-2 truncate">
                                        onboarding
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                              {/* Arrow (moved to the right) */}
                              <img
                                src="/download-small-arrow.svg"
                                alt="Arrow Icon"
                                className="h-3 w-3 ml-auto md:ml-4 ml-3"
                              />
                            </button>

                            {/* Dropdown List */}
                            {isToUser && (
                              <div
                                className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-50"
                                style={{
                                  maxHeight: "200px", // Optional: limit height
                                }}
                              >
                                {fromOptions.map((option) => (
                                  <div
                                    key={option.value}
                                    onClick={() => {
                                      setSelectedOption(option); // Set selected option when clicked
                                      setToUser(false); // Close dropdown
                                    }}
                                    className="px-4 py-2 font-medium hover:bg-black hover:text-white text-sm flex items-center cursor-pointer"
                                  >
                                    <img
                                      src={option.image}
                                      alt="Option Icon"
                                      className="h-5 w-5 mr-2"
                                    />
                                    <span>{option.label}</span>
                                    <span className="text-[#005A9C] ml-2">
                                      {option.role}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* To Section */}
                      <div className="flex items-start mb-4">
                        <label className="w-1/4 text-sm font-medium text-labelLightColour">
                          To:
                        </label>
                        <div className="w-3/4 relative">
                          <div className="flex flex-wrap items-center gap-2 border border-gray-300 rounded-md px-3 py-2">
                            {recipients.map((recipient, index) => (
                              <span
                                key={index}
                                className="inline-flex items-center px-3 py-1 rounded-lg bg-[#3047EC] text-white  text-xs font-medium"
                              >
                                <span className="underline">{recipient}</span>
                                <button
                                  onClick={() => handleRemoveRecipient(index)}
                                  className="ml-2 bg-white rounded  hover:text-gray-700"
                                >
                                  <img
                                    src="/cross-black.svg"
                                    alt="Arrow Icon"
                                    className="h-2 w-2 m-1 " // ml-auto pushes the arrow to the right
                                  />{" "}
                                </button>
                              </span>
                            ))}
                            <input
                              type="text"
                              placeholder="Add recipient"
                              value={inputValue}
                              onChange={handleInputChangeAddRecipient} // Update input value on change
                              onKeyDown={(e) => {
                                if (
                                  e.key === "Enter" &&
                                  e.target.value.trim()
                                ) {
                                  handleAddRecipientButton(); // Use validation on Enter
                                }
                              }}
                              className="flex-1 text-sm focus:outline-none"
                            />
                            <button
                              onClick={handleAddRecipientButton} // Use validation on click
                              className="ml-auto px-2 py-0 bg-[#3047EC] text-white text-md rounded-md hover:bg-[#3047EC]"
                            >
                              +
                            </button>
                          </div>
                          {/* Suggestions Dropdown */}
                          {showSuggestions && inputValue && (
                            <div className="absolute top-full mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg z-10">
                              {filteredSuggestions.length > 0 ? (
                                filteredSuggestions.map((suggestion, index) => (
                                  <div
                                    key={index}
                                    onClick={() =>
                                      handleAddRecipient(suggestion)
                                    }
                                    className="px-3 py-2 cursor-pointer hover:bg-black hover:text-white text-sm text-gray-700"
                                  >
                                    {suggestion}
                                  </div>
                                ))
                              ) : (
                                <div className="px-3 py-2 text-sm text-gray-500">
                                  No matches found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Subject */}
                      <div className="flex items-center mb-4">
                        <label className="w-1/4 text-sm font-medium text-labelLightColour">
                          Subject:
                        </label>
                        <input
                          type="text"
                          value={subject}
                          onChange={(e) => setSubject(e.target.value)}
                          placeholder="Subject goes here"
                          className="w-3/4 border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none"
                        />
                      </div>
                      {/* Message */}
                      <div className="flex items-start mb-4">
                        <label className="w-1/4 text-sm font-medium text-labelLightColour">
                          Message:
                        </label>
                        <textarea
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          placeholder="Type your message here..."
                          rows={5}
                          className="w-3/4  resize-none  max-h-[90%] overflow-y-auto border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none"
                        />
                      </div>
                    </div>
                    {/* Attachments */}
                    <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                      <div className="flex items-center space-x-2 px-4">
                        <h1 className="text-md font-medium mb-2">
                          Attachments
                        </h1>
                      </div>
                      <div className="space-y-4 ">
                        <div className="flex flex-row pr-10">
                          <div
                            key={2}
                            className="p-4 w-full sm:w-2/4 rounded-md bg-gray-50 relative"
                          >
                            {/* Delete Icon */}
                            <button
                              onClick={() => console.log("Delete")}
                              className="absolute top-2 right-2 p-2"
                            >
                              <img
                                src="/trash.svg" // Replace with your delete icon
                                alt="Delete Icon"
                                className="h-4 w-4"
                              />
                            </button>

                            <div className="flex items-center">
                              <div className="h-10 w-10 flex-shrink-0">
                                <img
                                  src="/word-icon.svg"
                                  alt="Avatar Icon"
                                  className="h-10 w-10"
                                />
                              </div>
                              <div className="ml-4">
                                <p className="text-sm">
                                  <span className="font-medium">
                                    Advisor Signature.doc
                                  </span>
                                </p>
                                <p className="text-xs mt-1 text-black flex items-center space-x-2">
                                  <span>22-01-2024 | 4.56 PM</span>
                                </p>
                                <p className="text-xs font-semibold text-black flex items-center space-x-2">
                                  <span>122.4 KB</span>
                                </p>
                              </div>
                            </div>

                            {/* View Button */}
                            <div className="absolute bottom-2 right-0">
                              <button
                                onClick={() => console.log("View")}
                                className="px-4 py-2 text-black underline text-xs font-medium"
                              >
                                View
                              </button>
                            </div>
                          </div>
                          <div
                            key={2}
                            onClick={toggleAddTemplatePopup}
                            className="p-4 ml-2 font-medium sm:w-1/3 md:w-20 rounded-md bg-[#F9F9F9] relative"
                          >
                            <div className="flex flex-col items-center">
                              <div className="flex-shrink-2">
                                <img
                                  src="/Paperclip.svg"
                                  alt="Add Template Icon"
                                  className="h-4 w-4"
                                />
                              </div>
                              <div>
                                <p className="text-xs text-center">
                                  <span className="font-medium ">
                                    Add Template
                                  </span>
                                </p>
                              </div>
                              {/* Will use when file is available */}
                              {/* <div className="p-6">
                              <h1 className="text-lg font-bold mb-4">
                                Upload and Preview a .docx File
                              </h1>
                              <input type="file" onChange={handleFileUpload} />

                              {isPopupOpen && selectedFile && (
                                <ViewDocumentPopup
                                  fileName={selectedFile.name}
                                  file={selectedFile}
                                  onClose={() => setPopupOpen(false)}
                                />
                              )}
                            </div> */}
                            </div>
                          </div>
                          {istemplateOpen && (
                            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                              <div className="w-[90%] md:w-[70%] max-w-screen bg-[#F9F9F9] rounded-lg p-6 shadow-lg max-h-[90%] overflow-y-auto">
                                {/* Header */}
                                <div className="flex items-center justify-between mb-4">
                                  <h2 className="text-lg text-center w-full font-semibold">
                                    Add Template
                                  </h2>
                                  <button onClick={toggleAddTemplatePopup}>
                                    <img
                                      src="/add.svg"
                                      alt="Close"
                                      className="w-10 h-10"
                                    />
                                  </button>
                                </div>
                                <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                                  <div className="flex items-center space-x-2 px-4">
                                    <h1 className="text-md font-medium mb-2">
                                      Templates
                                    </h1>
                                  </div>
                                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {documents.map((doc) => (
                                      <div
                                        key={doc.id}
                                        className="p-4 w-full rounded-md bg-gray-50 relative"
                                      >
                                        {/* Delete Icon */}
                                        <button
                                          onClick={() => {
                                            setCurrentDoc(doc);
                                            setIsDocDelete(true);
                                          }}
                                          className="absolute top-2 right-2 p-2"
                                        >
                                          <img
                                            src="/trash.svg"
                                            alt="Delete Icon"
                                            className="h-4 w-4"
                                          />
                                        </button>

                                        {/* Document Details */}
                                        <div className="flex items-center">
                                          <div className="h-10 w-10 flex-shrink-0">
                                            <img
                                              src={doc.icon}
                                              alt="Document Icon"
                                              className="h-10 w-10"
                                            />
                                          </div>
                                          <div className="ml-4">
                                            <p className="text-sm">
                                              <span className="font-medium">
                                                {doc.name}
                                              </span>
                                            </p>
                                            <p className="text-xs mt-1 text-black">
                                              {doc.date}
                                            </p>
                                            <p className="text-xs font-semibold text-black">
                                              {doc.size}
                                            </p>
                                          </div>
                                        </div>

                                        {/* Download Button */}
                                        <div className="absolute bottom-2 right-2">
                                          <button
                                            onClick={() =>
                                              console.log(
                                                `Download ${doc.name}`
                                              )
                                            }
                                            className="px-4 py-2 text-black underline text-xs font-medium"
                                          >
                                            Download
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  {isDocDelete && (
                                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                      <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                                        <button class="absolute top-3 right-3 text-black text-xl font-bold">
                                          &times;
                                        </button>

                                        <div class="flex justify-center items-center mb-4">
                                          <div class="flex items-center justify-center">
                                            <img
                                              src="/delete-warning.svg"
                                              alt="Add Template Icon"
                                              className="h-10 w-10"
                                            />
                                          </div>
                                        </div>

                                        <h2 class="text-lg font-medium mb-2">
                                          Are you sure?
                                        </h2>
                                        <p class="text-sm text-black mb-4">
                                          Are you sure you want to remove <br />{" "}
                                          <span class="font-medium italic">
                                            {currentDoc.name}
                                          </span>{" "}
                                          file?
                                        </p>

                                        <div class="flex justify-center space-x-4">
                                          <button
                                            onClick={() => {
                                              setIsDocDelete(false);
                                            }}
                                            class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                                          >
                                            No
                                          </button>
                                          <button
                                            onClick={() => {
                                              setIsFileExisted(false);
                                            }}
                                            class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                                          >
                                            Yes
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                                  <div className="border-b pb-6 mb-6">
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                      {/* Heading */}
                                      <h1 className="text-md font-medium mb-2 sm:mb-0">
                                        File Upload
                                      </h1>

                                      {/* Actions: Search, Select All, Remove */}
                                      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 w-full sm:w-auto">
                                        <button className="flex items-center bg-[#005A9C] text-white  font-medium text-xs border border-[#005A9C] py-2 lg:px-4 px-1 rounded-xl">
                                          <img
                                            src="/Plus-white.svg"
                                            alt="Add Icon"
                                            className="mr-2 ml-2 h-3 w-3"
                                          />
                                          <span className="inline">
                                            Upload Files
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                      <label className="bg-[#FAFAFA] w-full border rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                                        <input
                                          type="file"
                                          id="fileUpload"
                                          onChange={handleFileChange}
                                          className="hidden"
                                        />
                                        <img
                                          src="/folder-add.svg"
                                          alt="Success Icon"
                                          className="h-4 w-4"
                                        />{" "}
                                        <p className="mt-2 text-gray-500 text-sm">
                                          Drag & Drop or <br />
                                          <p className="underline">
                                            Click to Upload
                                          </p>
                                        </p>
                                      </label>
                                    </div>
                                    {isFileExisted && (
                                      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                        <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                                          <button class="absolute top-3 right-3 text-black text-xl font-bold">
                                            &times;
                                          </button>

                                          <div class="flex justify-center items-center mb-4">
                                            <div class="flex items-center justify-center">
                                              <img
                                                src="/warning-circle.svg"
                                                alt="Add Template Icon"
                                                className="h-10 w-10"
                                              />
                                            </div>
                                          </div>

                                          <h2 class="text-lg font-medium mb-2">
                                            Are you sure?
                                          </h2>
                                          <p class="text-sm text-black mb-4">
                                            Do you want to replace <br />
                                            <span class="font-medium italic">
                                              {file.name}
                                            </span>{" "}
                                            file?
                                          </p>

                                          <div class="flex justify-center space-x-4">
                                            <button
                                              onClick={() => {
                                                setIsFileExisted(false);
                                              }}
                                              class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                                            >
                                              No
                                            </button>
                                            <button
                                              onClick={() => {
                                                setnewFile(currentFile);
                                                setIsFileExisted(false);
                                              }}
                                              class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                                            >
                                              Yes
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="flex flex-col sm:flex-row sm:items-center text-sm pl-5 mt-2 w-full">
                                      {/* Save Uploads Checkbox */}
                                      <div className="flex items-center w-full sm:w-auto mb-2 sm:mb-0">
                                        <input
                                          type="checkbox"
                                          id="selectUser"
                                          className="custom-checkbox h-3 w-3 mr-2"
                                        />
                                        <span className="text-black">
                                          Save Uploads to File List
                                        </span>
                                      </div>
                                      {/* Filters Section */}
                                      <div className="flex flex-wrap mt-2 sm:mt-0 sm:mr-4 mr-0 sm:ml-auto space-x-2">
                                        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                          PNG
                                        </span>
                                        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                          JPEG
                                        </span>
                                        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                          PDF
                                        </span>
                                        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                          &#62; 10 MB
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                    {/* Heading */}
                                    <h1 className="text-md font-medium mb-2 sm:mb-0">
                                      File List
                                    </h1>

                                    {/* Actions: Search, Select All, Remove */}
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 w-full sm:w-auto">
                                      {/* Search Box */}
                                      <div className="relative font-normal w-full sm:w-auto">
                                        <input
                                          type="text"
                                          className="w-full sm:w-auto p-2 pl-6 text-xs border rounded-xl focus:ring-2 focus:ring-indigo-500"
                                          placeholder="Search Files"
                                          value={searchQuery}
                                          onBlur={handleBlur}
                                          onChange={(e) => {
                                            setCurrentPage(1);
                                            setSearchQuery(e.target.value);
                                          }}
                                        />
                                        <span className="absolute left-2 top-3 text-gray-500">
                                          <img
                                            src="/search-normal.svg"
                                            alt="Search Icon"
                                            className="mr-2"
                                          />
                                        </span>
                                      </div>

                                      {/* Select All Button */}
                                      <div className="flex items-center text-sm pl-2 w-full sm:w-auto">
                                        <input
                                          type="checkbox"
                                          id="selectUser"
                                          className="custom-checkbox h-3 w-3 mr-2"
                                        />
                                        <span className="text-[#888888]">
                                          Select All
                                        </span>
                                      </div>

                                      {/* Remove Button */}
                                      <div className="w-full sm:w-auto text-xs">
                                        <button className="w-full sm:w-auto border bg-white text-black font-medium border-gray-300 h-8 rounded-xl text-sm px-4 flex justify-center sm:justify-between items-center focus:outline-none">
                                          <div className="flex items-center">
                                            <img
                                              src="/trash.svg"
                                              alt="Remove Icon"
                                              className="h-3 w-3 mr-2"
                                            />
                                            Remove
                                          </div>
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-2 gap-4">
                                    {documents.map((doc) => (
                                      <div
                                        key={doc.id}
                                        className="p-4 w-full rounded-md bg-[#F9F9F9] relative"
                                      >
                                        {/* Checkbox */}
                                        <div className="absolute top-2 left-2">
                                          <input
                                            type="checkbox"
                                            id="selectUser"
                                            className="custom-checkbox h-2 w-2 mr-2"
                                          />
                                        </div>

                                        {/* Delete Icon */}
                                        <button
                                          onClick={() =>
                                            console.log(`Delete ${doc.name}`)
                                          }
                                          className="absolute top-2 right-2 p-2"
                                        >
                                          <img
                                            src="/trash.svg"
                                            alt="Delete Icon"
                                            className="h-4 w-4"
                                          />
                                        </button>

                                        {/* Document Details */}
                                        <div className="flex items-center">
                                          <div className="h-10 w-10 flex-shrink-0">
                                            <img
                                              src={doc.icon}
                                              alt="Document Icon"
                                              className="h-10 w-10"
                                            />
                                          </div>
                                          <div className="ml-4">
                                            <p className="text-sm">
                                              <span className="font-medium">
                                                {doc.name}
                                              </span>
                                            </p>
                                            <p className="text-xs mt-1 text-black">
                                              {doc.date}
                                            </p>
                                            <p className="text-xs font-semibold text-black">
                                              {doc.size}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex justify-between font-medium text-sm items-center mt-6">
                                  <button
                                    onClick={toggleAddTemplatePopup}
                                    className="px-4 py-2 rounded-full bg-white text-black border-2 border-black "
                                  >
                                    Back
                                  </button>
                                  <button className="px-8 py-2 rounded-full bg-black text-white">
                                    Select (2)
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex text-sm pl-2 items-center">
                        <input
                          type="checkbox"
                          id="selectUser"
                          className="custom-checkbox h-3 w-3 mr-2"
                        />{" "}
                        <span>Include e-Signatures</span>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex justify-between font-medium text-sm items-center mt-6">
                      <button
                        onClick={toggleSendMessagePopup}
                        className="px-4 py-2 rounded-full bg-white text-black border-2 border-black "
                      >
                        Save Draft
                      </button>
                      <button className="px-8 py-2 rounded-full bg-black text-white">
                        Send
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Remove Button */}
              <div className="w-full sm:w-auto">
                <button
                  onClick={(e) => removeUsers(e)}
                  className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                >
                  <div className="flex items-center">
                    <img
                      src="/trash.svg"
                      alt="Remove Icon"
                      className="h-5 w-5 mr-2"
                    />
                    Remove
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div>
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                  <tr className="mb-4">
                    <th
                      key="1"
                      className="cursor-pointer font-medium px-4 py-2 border rounded-l text-left"
                    >
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          id="selectUser"
                          checked={selectAll} // Bind to Select All state
                          onChange={toggleSelectAll} // Handle toggle
                          className="custom-checkbox h-3 w-3 mr-2"
                        />{" "}
                        <span>All</span>
                      </div>
                    </th>

                    {/* Dynamic Headers */}
                    {headers.map((header) => (
                      <th
                        onClick={() => handleSort(header.key)}
                        key={header.label}
                        className="cursor-pointer font-medium px-4 py-2  border text-left"
                      >
                        <div className="flex items-center justify-between w-full">
                          <span>{header.label}</span>
                          {header.label !== "" && (
                            <img
                              src="/sort.svg"
                              alt="Sort Icon"
                              className="w-4 h-4 ml-auto"
                            />
                          )}
                        </div>
                      </th>
                    ))}

                    {/* Star Column */}
                    <th className="text-center border py-4 rounded-r">
                      <img
                        src="/unfilled-star.svg"
                        alt="Star Icon"
                        className="w-5 h-5 ml-4 mr-10"
                      />
                    </th>
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm mt-4 font-medium text-black">
                    {customers.map((customer) => (
                      <tr className="px-6 py-2 bg-white">
                        <td className="px-6 rounded-l border-r-0 border py-2">
                          <input
                            type="checkbox"
                            id="selectUser"
                            checked={selectedCustomers.includes(customer.id)} // Check if selected
                            onChange={() => toggleTableSelection(customer.id)}
                            className="custom-checkbox h-4 w-4 rounded"
                          />
                        </td>
                        <td
                          onClick={() => {
                            dispatch(clearAdvisorName());
                            let redirectState = {
                              path: `/advisor-details/${customer.id}/${customer.previous_user_id}`,
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            };
                            sessionStorage.setItem(
                              "redirectAfterLogin",
                              JSON.stringify(redirectState)
                            );
                            navigate(
                              `/advisor-details/${customer.id}/${customer.previous_user_id}`,
                              {
                                state: {
                                  from: location.pathname,
                                  historyStack: [
                                    ...(location.state?.historyStack || []),
                                    location.pathname,
                                  ],
                                },
                              }
                            );
                          }}
                          className=" cursor-pointer px-4 py-4 border-b border-t text-left min-w-[200px] max-w-[400px] font-medium flex items-center space-x-2"
                        >
                          <img
                            src="/avatar.svg"
                            className="w-8 h-8 rounded-full"
                          />
                          <span className="text-left underline">
                            {customer.type == "Corporate"
                              ? customer.company_name
                              : customer.first_name + " " + customer.last_name}
                          </span>
                        </td>
                        <td className="px-4 py-2 w-40 border-b border-t relative">
                          {customer.email_address}
                        </td>
                        <td className="px-4 w-20 border-b border-t text-center py-2">
                          <button
                            className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                              customer.status == "ACTIVE"
                                ? " text-[#34C046] bg-[#34C046] bg-opacity-20"
                                : ""
                            }
                              ${
                                customer.status == "ONBOARDING"
                                  ? " text-[#005A9C] bg-[#005A9C] bg-opacity-20"
                                  : ""
                              }
                            ${
                              customer.status == "To Review"
                                ? " text-[#F77E27] bg-[#F77E27] bg-opacity-20"
                                : ""
                            }
                                ${
                                  customer.status == "In Progress"
                                    ? " text-[#FFC421] bg-[#FFC421] bg-opacity-20"
                                    : ""
                                }
                                 ${
                                   customer.status == "PENDING"
                                     ? " text-[#FFC421] bg-[#FFC421] bg-opacity-20"
                                     : ""
                                 }
                                ${
                                  customer.status == "To Review"
                                    ? " text-[#F77E27] bg-[#F77E27] bg-opacity-20"
                                    : ""
                                }
                                ${
                                  customer.status == "Sent for Resubmit"
                                    ? " text-[#3047EC] bg-[#3047EC] bg-opacity-20"
                                    : ""
                                }
                                ${
                                  customer.status == "Sent for Approval"
                                    ? " text-[#3047EC] bg-[#3047EC] bg-opacity-20"
                                    : ""
                                }
                                  ${
                                    customer.status == "REJECTED"
                                      ? " text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                                      : ""
                                  }
                                    ${
                                      customer.status == "BLOCKED"
                                        ? " text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                                        : ""
                                    }
                                   ${
                                     customer.status == "DELETED"
                                       ? " text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                                       : ""
                                   }
                               ${
                                 customer.status == "SUSPENDED"
                                   ? " text-white bg-[#FF5050]"
                                   : ""
                               }
                               ${
                                 customer.status == "CLOSED"
                                   ? " text-[#000000] bg-[#000000] bg-opacity-20"
                                   : ""
                               }
                                ${
                                  customer.status == "ARCHIEVED"
                                    ? " text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20"
                                    : ""
                                }
                              `}
                          >
                            <span className="mr-6 text-center">
                              {customer.status}
                            </span>
                          </button>
                        </td>

                        {/* Dropdown Button */}
                        <td className="px-4 py-2 w-40 border-b border-t relative">
                          {customer.client_id}
                        </td>

                        <td className="px-4 w-20 py-2 border-b border-t text-ellipsis  overflow-hidden whitespace-nowrap">
                          {customer.type}
                        </td>

                        <td className="px-4 py-2 text-left border-b border-t">
                          {customer.cash_accounts}
                        </td>

                        <td className="px-4 py-2 text-center border-b border-t">
                          {customer.portfolio}
                        </td>

                        <td className="px-4 py-2 text-center border-b border-t">
                          {customer.credit}
                        </td>

                        <td className="px-4 py-2 text-ellipsis overflow-hidden border-b border-t">
                          <div className="px-2">
                            <span>{customer.location}</span>
                          </div>
                          <div className="px-2">
                            <span className="text-[#75E380]">Low</span>
                          </div>
                        </td>
                        <td className="px-4 py-2 border-b border-t  text-ellipsis overflow-hidden whitespace-nowrap">
                          <div className="flex items-center space-x-2">
                            <img
                              src="/clock.svg"
                              alt="Time Icon"
                              className="h-4 w-4"
                            />
                            <span className="rounded-xl">
                              {formatDateTime(customer.created_at)}
                            </span>
                          </div>
                        </td>

                        <td className="text-center rounded-r border-r border-b border-t">
                          {selectedCustomers.includes(customer.id) && (
                            <img
                              src="/filled-star.svg"
                              alt="Star Icon"
                              className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                            />
                          )}
                          {!selectedCustomers.includes(customer.id) && (
                            <img
                              src="/unfilled-star.svg"
                              alt="Star Icon"
                              className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                            />
                          )}
                        </td>
                      </tr>
                    ))}{" "}
                  </tbody>
                )}
              </table>
            </div>

            <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
              {/* Entries Info Section */}
              <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                Showing {showRecords * (currentPage - 1) + 1} to{" "}
                {currentPage === totalPages || totalPages == 0
                  ? totalCount
                  : Math.max(showRecords * currentPage, customers.length)}{" "}
                of {totalCount} entries
              </div>

              {/* Pagination Section */}
              <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                {/* Previous Button */}
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Prev
                </button>

                {/* Page Buttons */}
                {Array.from({ length: Math.min(totalPages, 5) }).map(
                  (_, index) => {
                    const startPage = Math.max(
                      1,
                      Math.min(totalPages - 4, currentPage - 2)
                    );
                    const page = startPage + index;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded ${
                          currentPage === page
                            ? "bg-black text-white"
                            : "bg-white border border-gray-300 text-black"
                        }`}
                      >
                        {page}
                      </button>
                    );
                  }
                )}

                {/* Next Button */}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {filter == "to_review" && (
        <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/profile-black.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Review Advisor List
              </span>
            </div>
            <button
              disabled={true}
              className="flex items-center text-[#005A9C] bg-white  border border-[#005A9C] py-2 lg:px-4 px-1 rounded-xl"
            >
              <img src="/Plus.svg" alt="Add Icon" className="mr-2 ml-2" />
              <span className="lg:inline hidden">Add Advisor</span>
            </button>
          </div>
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-6 text-sm border rounded-xl"
                    placeholder="Search Advisor"
                    value={searchQuery}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {" "}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-4 items-center">
              {/* Filter Button */}
              <div className="w-full sm:w-auto">
                <button
                  onClick={togglePopup}
                  className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                >
                  <div className="flex items-center">
                    <img
                      src="/filter-sort-black.svg"
                      alt="Filter Icon"
                      className="h-5 w-5 mr-2"
                    />
                    Filter
                  </div>
                </button>
              </div>

              {/* Modal Popup */}
              {isOpen && (
                <div className="fixed inset-0 w-full flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
                  <div className="bg-white rounded-lg w-[90%] md:w-[60%] max-w-[500px] p-6 max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Filters
                      </h2>
                      <button onClick={togglePopup}>
                        <img
                          src="/add.svg"
                          alt="Close"
                          className="w-8 h-8 md:w-10 md:h-10"
                        />
                      </button>
                    </div>

                    {/* Modal Content */}
                    <div className="grid grid-cols-1 gap-4">
                      <Dropdown
                        label="Applicant's Location"
                        options={users}
                        onSelect={handleSelectInvestmentManagerAccount}
                      />
                      <Dropdown
                        label="Default Currency"
                        options={users}
                        onSelect={handleSelectInvestmentManagerAccount}
                      />
                      <Dropdown
                        label="Risk of Location"
                        options={users}
                        onSelect={handleSelectInvestmentManagerAccount}
                      />

                      <div className="flex flex-wrap md:flex-nowrap md:gap-4 gap-0 items-center">
                        {/* First Cash Amount Input */}
                        <div className="flex-1 min-w-[40%]">
                          <label className="block text-sm text-[#464646] mb-1">
                            Cash Amount
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              value={
                                startAmount ? formatNumber(startAmount) : ""
                              }
                              onChange={handleInputChange}
                              className="block p-2 w-full text-black font-medium border border-gray-300 rounded-md text-sm"
                            />
                            <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                              AU$
                            </span>
                          </div>
                        </div>

                        {/* 'to' Label */}
                        <div className="w-full md:w-auto text-center mt-4 md:text-left">
                          <span className="block md:inline text-sm text-black  md:mt-4">
                            to
                          </span>
                        </div>

                        {/* Second Cash Amount Input */}
                        <div className="flex-1 min-w-[40%]">
                          <label className="block text-sm text-[#464646] mb-1 invisible">
                            Hidden Label
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              value={endAmount ? formatNumber(endAmount) : ""}
                              onChange={handleInputChangeEndAmount}
                              className="block p-2 w-full text-black font-medium border border-gray-300 rounded-md text-sm"
                            />
                            <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                              AU$
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex flex-col md:flex-row justify-center md:space-x-4 space-y-2 md:space-y-0 mt-6">
                      <button
                        onClick={togglePopup}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        className={`px-6 py-2 rounded-lg ${
                          isNewChange
                            ? "bg-gray-400"
                            : "bg-black text-white hover:bg-gray-800"
                        }`}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Send Message Button */}
              <div className="w-full sm:w-auto">
                <button
                  onClick={toggleSendMessagePopup}
                  className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                >
                  <div className="flex items-center">
                    <img
                      src="/send-message.svg"
                      alt="Send Message Icon"
                      className="h-5 w-5 mr-2"
                    />
                    Send Message
                  </div>
                </button>
              </div>
              {isSendMessageOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="w-[90%] md:w-[50%] max-w-[700px] bg-[#F9F9F9] rounded-lg p-6 shadow-lg max-h-[90%] overflow-y-auto">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg text-center w-full font-semibold">
                        New Message
                      </h2>
                      <button onClick={toggleSendMessagePopup}>
                        <img src="/add.svg" alt="Close" className="w-10 h-10" />
                      </button>
                    </div>

                    <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
                      {" "}
                      <div className="flex items-center mb-4 w-full w-full">
                        <label className="w-1/4 text-sm font-medium text-labelLightColour">
                          From:
                        </label>
                        <div className="w-3/4">
                          <div className="relative w-full md:w-full">
                            {/* Dropdown Button */}
                            <button
                              onClick={() => setToUser(!isToUser)}
                              className="w-full md:w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-2 py-2 pr-10 flex justify-between items-center focus:outline-none bg-white text-black"
                            >
                              <div className="flex items-center flex-grow">
                                {/* Selected Image */}
                                <img
                                  src={selectedOption?.image || "/avatar.svg"} // Display image from selected option or default image
                                  alt="User Icon"
                                  className="h-5 w-5 mr-2"
                                />
                                {/* Display selected name and role */}
                                <div className="flex flex-col  md:flex-row truncate">
                                  {selectedOption ? (
                                    <>
                                      <span className="mr-2 truncate">
                                        {selectedOption.label}
                                      </span>
                                      <span className="text-[#005A9C] truncate">
                                        {selectedOption.role}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <span className="truncate">
                                        name here
                                      </span>
                                      <span className="text-[#005A9C] ml-2 truncate">
                                        onboarding
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                              {/* Arrow (moved to the right) */}
                              <img
                                src="/download-small-arrow.svg"
                                alt="Arrow Icon"
                                className="h-3 w-3 ml-auto md:ml-4 ml-3"
                              />
                            </button>

                            {/* Dropdown List */}
                            {isToUser && (
                              <div
                                className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-50"
                                style={{
                                  maxHeight: "200px", // Optional: limit height
                                }}
                              >
                                {fromOptions.map((option) => (
                                  <div
                                    key={option.value}
                                    onClick={() => {
                                      setSelectedOption(option); // Set selected option when clicked
                                      setToUser(false); // Close dropdown
                                    }}
                                    className="px-4 py-2 font-medium hover:bg-black hover:text-white text-sm flex items-center cursor-pointer"
                                  >
                                    <img
                                      src={option.image}
                                      alt="Option Icon"
                                      className="h-5 w-5 mr-2"
                                    />
                                    <span>{option.label}</span>
                                    <span className="text-[#005A9C] ml-2">
                                      {option.role}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* To Section */}
                      <div className="flex items-start mb-4">
                        <label className="w-1/4 text-sm font-medium text-labelLightColour">
                          To:
                        </label>
                        <div className="w-3/4 relative">
                          <div className="flex flex-wrap items-center gap-2 border border-gray-300 rounded-md px-3 py-2">
                            {recipients.map((recipient, index) => (
                              <span
                                key={index}
                                className="inline-flex items-center px-3 py-1 rounded-lg bg-[#3047EC] text-white  text-xs font-medium"
                              >
                                <span className="underline">{recipient}</span>
                                <button
                                  onClick={() => handleRemoveRecipient(index)}
                                  className="ml-2 bg-white rounded  hover:text-gray-700"
                                >
                                  <img
                                    src="/cross-black.svg"
                                    alt="Arrow Icon"
                                    className="h-2 w-2 m-1 " // ml-auto pushes the arrow to the right
                                  />{" "}
                                </button>
                              </span>
                            ))}
                            <input
                              type="text"
                              placeholder="Add recipient"
                              value={inputValue}
                              onChange={handleInputChangeAddRecipient} // Update input value on change
                              onKeyDown={(e) => {
                                if (
                                  e.key === "Enter" &&
                                  e.target.value.trim()
                                ) {
                                  handleAddRecipientButton(); // Use validation on Enter
                                }
                              }}
                              className="flex-1 text-sm focus:outline-none"
                            />
                            <button
                              onClick={handleAddRecipientButton} // Use validation on click
                              className="ml-auto px-2 py-0 bg-[#3047EC] text-white text-md rounded-md hover:bg-[#3047EC]"
                            >
                              +
                            </button>
                          </div>
                          {/* Suggestions Dropdown */}
                          {showSuggestions && inputValue && (
                            <div className="absolute top-full mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg z-10">
                              {filteredSuggestions.length > 0 ? (
                                filteredSuggestions.map((suggestion, index) => (
                                  <div
                                    key={index}
                                    onClick={() =>
                                      handleAddRecipient(suggestion)
                                    }
                                    className="px-3 py-2 cursor-pointer hover:bg-black hover:text-white text-sm text-gray-700"
                                  >
                                    {suggestion}
                                  </div>
                                ))
                              ) : (
                                <div className="px-3 py-2 text-sm text-gray-500">
                                  No matches found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Subject */}
                      <div className="flex items-center mb-4">
                        <label className="w-1/4 text-sm font-medium text-labelLightColour">
                          Subject:
                        </label>
                        <input
                          type="text"
                          value={subject}
                          onChange={(e) => setSubject(e.target.value)}
                          placeholder="Subject goes here"
                          className="w-3/4 border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none"
                        />
                      </div>
                      {/* Message */}
                      <div className="flex items-start mb-4">
                        <label className="w-1/4 text-sm font-medium text-labelLightColour">
                          Message:
                        </label>
                        <textarea
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          placeholder="Type your message here..."
                          rows={5}
                          className="w-3/4  resize-none  max-h-[90%] overflow-y-auto border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none"
                        />
                      </div>
                    </div>
                    {/* Attachments */}
                    <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                      <div className="flex items-center space-x-2 px-4">
                        <h1 className="text-md font-medium mb-2">
                          Attachments
                        </h1>
                      </div>
                      <div className="space-y-4">
                        <div className="flex flex-row">
                          <div
                            key={2}
                            className="p-4 w-full sm:w-2/4 rounded-md bg-gray-50 relative"
                          >
                            {/* Delete Icon */}
                            <button
                              onClick={() => console.log("Delete")}
                              className="absolute top-2 right-2 p-2"
                            >
                              <img
                                src="/trash.svg" // Replace with your delete icon
                                alt="Delete Icon"
                                className="h-4 w-4"
                              />
                            </button>

                            <div className="flex items-center">
                              <div className="h-10 w-10 flex-shrink-0">
                                <img
                                  src="/word-icon.svg"
                                  alt="Avatar Icon"
                                  className="h-10 w-10"
                                />
                              </div>
                              <div className="ml-4">
                                <p className="text-sm">
                                  <span className="font-medium">
                                    Advisor Signature.doc
                                  </span>
                                </p>
                                <p className="text-xs mt-1 text-black flex items-center space-x-2">
                                  <span>22-01-2024 | 4.56 PM</span>
                                </p>
                                <p className="text-xs font-semibold text-black flex items-center space-x-2">
                                  <span>122.4 KB</span>
                                </p>
                              </div>
                            </div>

                            {/* View Button */}
                            <div className="absolute bottom-2 right-0">
                              <button
                                onClick={() => console.log("View")}
                                className="px-4 py-2 text-black underline text-xs font-medium"
                              >
                                View
                              </button>
                            </div>
                          </div>
                          <div
                            key={2}
                            onClick={toggleAddTemplatePopup}
                            className="p-4 ml-2 font-medium sm:w-1/3 md:w-20 rounded-md bg-[#F9F9F9] relative"
                          >
                            <div className="flex flex-col items-center">
                              <div className="flex-shrink-0">
                                <img
                                  src="/Paperclip.svg"
                                  alt="Add Template Icon"
                                  className="h-4 w-4"
                                />
                              </div>
                              <div>
                                <p className="text-xs text-center">
                                  <span className="font-medium ">
                                    Add Template
                                  </span>
                                </p>
                              </div>
                              {/* Will use when file is available */}
                              {/* <div className="p-6">
                              <h1 className="text-lg font-bold mb-4">
                                Upload and Preview a .docx File
                              </h1>
                              <input type="file" onChange={handleFileUpload} />

                              {isPopupOpen && selectedFile && (
                                <ViewDocumentPopup
                                  fileName={selectedFile.name}
                                  file={selectedFile}
                                  onClose={() => setPopupOpen(false)}
                                />
                              )}
                            </div> */}
                            </div>
                          </div>
                          {istemplateOpen && (
                            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                              <div className="w-[90%] md:w-[70%] max-w-screen bg-[#F9F9F9] rounded-lg p-6 shadow-lg max-h-[90%] overflow-y-auto">
                                {/* Header */}
                                <div className="flex items-center justify-between mb-4">
                                  <h2 className="text-lg text-center w-full font-semibold">
                                    Add Template
                                  </h2>
                                  <button onClick={toggleAddTemplatePopup}>
                                    <img
                                      src="/add.svg"
                                      alt="Close"
                                      className="w-10 h-10"
                                    />
                                  </button>
                                </div>
                                <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                                  <div className="flex items-center space-x-2 px-4">
                                    <h1 className="text-md font-medium mb-2">
                                      Templates
                                    </h1>
                                  </div>
                                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {documents.map((doc) => (
                                      <div
                                        key={doc.id}
                                        className="p-4 w-full rounded-md bg-gray-50 relative"
                                      >
                                        {/* Delete Icon */}
                                        <button
                                          onClick={() => {
                                            setCurrentDoc(doc);
                                            setIsDocDelete(true);
                                          }}
                                          className="absolute top-2 right-2 p-2"
                                        >
                                          <img
                                            src="/trash.svg"
                                            alt="Delete Icon"
                                            className="h-4 w-4"
                                          />
                                        </button>

                                        {/* Document Details */}
                                        <div className="flex items-center">
                                          <div className="h-10 w-10 flex-shrink-0">
                                            <img
                                              src={doc.icon}
                                              alt="Document Icon"
                                              className="h-10 w-10"
                                            />
                                          </div>
                                          <div className="ml-4">
                                            <p className="text-sm">
                                              <span className="font-medium">
                                                {doc.name}
                                              </span>
                                            </p>
                                            <p className="text-xs mt-1 text-black">
                                              {doc.date}
                                            </p>
                                            <p className="text-xs font-semibold text-black">
                                              {doc.size}
                                            </p>
                                          </div>
                                        </div>

                                        {/* Download Button */}
                                        <div className="absolute bottom-2 right-2">
                                          <button
                                            onClick={() =>
                                              console.log(
                                                `Download ${doc.name}`
                                              )
                                            }
                                            className="px-4 py-2 text-black underline text-xs font-medium"
                                          >
                                            Download
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  {isDocDelete && (
                                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                      <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                                        <button class="absolute top-3 right-3 text-black text-xl font-bold">
                                          &times;
                                        </button>

                                        <div class="flex justify-center items-center mb-4">
                                          <div class="flex items-center justify-center">
                                            <img
                                              src="/delete-warning.svg"
                                              alt="Add Template Icon"
                                              className="h-10 w-10"
                                            />
                                          </div>
                                        </div>

                                        <h2 class="text-lg font-medium mb-2">
                                          Are you sure?
                                        </h2>
                                        <p class="text-sm text-black mb-4">
                                          Are you sure you want to remove <br />{" "}
                                          <span class="font-medium italic">
                                            {currentDoc.name}
                                          </span>{" "}
                                          file?
                                        </p>

                                        <div class="flex justify-center space-x-4">
                                          <button
                                            onClick={() => {
                                              setIsDocDelete(false);
                                            }}
                                            class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                                          >
                                            No
                                          </button>
                                          <button
                                            onClick={() => {
                                              setIsFileExisted(false);
                                            }}
                                            class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                                          >
                                            Yes
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                                  <div className="border-b pb-6 mb-6">
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                      {/* Heading */}
                                      <h1 className="text-md font-medium mb-2 sm:mb-0">
                                        File Upload
                                      </h1>

                                      {/* Actions: Search, Select All, Remove */}
                                      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 w-full sm:w-auto">
                                        <button className="flex items-center bg-[#005A9C] text-white  font-medium text-xs border border-[#005A9C] py-2 lg:px-4 px-1 rounded-xl">
                                          <img
                                            src="/Plus-white.svg"
                                            alt="Add Icon"
                                            className="mr-2 ml-2 h-3 w-3"
                                          />
                                          <span className="inline">
                                            Upload Files
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                      <label className="bg-[#FAFAFA] w-full border rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                                        <input
                                          type="file"
                                          id="fileUpload"
                                          onChange={handleFileChange}
                                          accept=".pdf,.png,.jpeg"
                                          className="hidden"
                                        />
                                        <img
                                          src="/folder-add.svg"
                                          alt="Success Icon"
                                          className="h-4 w-4"
                                        />{" "}
                                        <p className="mt-2 text-gray-500 text-sm">
                                          Drag & Drop or <br />
                                          <p className="underline">
                                            Click to Upload
                                          </p>
                                        </p>
                                      </label>
                                    </div>
                                    {isFileExisted && (
                                      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                        <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                                          <button class="absolute top-3 right-3 text-black text-xl font-bold">
                                            &times;
                                          </button>

                                          <div class="flex justify-center items-center mb-4">
                                            <div class="flex items-center justify-center">
                                              <img
                                                src="/warning-circle.svg"
                                                alt="Add Template Icon"
                                                className="h-10 w-10"
                                              />
                                            </div>
                                          </div>

                                          <h2 class="text-lg font-medium mb-2">
                                            Are you sure?
                                          </h2>
                                          <p class="text-sm text-black mb-4">
                                            Do you want to replace <br />
                                            <span class="font-medium italic">
                                              {file.name}
                                            </span>{" "}
                                            file?
                                          </p>

                                          <div class="flex justify-center space-x-4">
                                            <button
                                              onClick={() => {
                                                setIsFileExisted(false);
                                              }}
                                              class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                                            >
                                              No
                                            </button>
                                            <button
                                              onClick={() => {
                                                setnewFile(currentFile);
                                                setIsFileExisted(false);
                                              }}
                                              class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                                            >
                                              Yes
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="flex flex-col sm:flex-row sm:items-center text-sm pl-5 mt-2 w-full">
                                      {/* Save Uploads Checkbox */}
                                      <div className="flex items-center w-full sm:w-auto mb-2 sm:mb-0">
                                        <input
                                          type="checkbox"
                                          id="selectUser"
                                          className="custom-checkbox h-3 w-3 mr-2"
                                        />
                                        <span className="text-black">
                                          Save Uploads to File List
                                        </span>
                                      </div>
                                      {/* Filters Section */}
                                      <div className="flex flex-wrap mt-2 sm:mt-0 sm:mr-4 mr-0 sm:ml-auto space-x-2">
                                        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                          PNG
                                        </span>
                                        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                          JPEG
                                        </span>
                                        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                          PDF
                                        </span>
                                        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                          &#62; 10 MB
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                    {/* Heading */}
                                    <h1 className="text-md font-medium mb-2 sm:mb-0">
                                      File List
                                    </h1>

                                    {/* Actions: Search, Select All, Remove */}
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 w-full sm:w-auto">
                                      {/* Search Box */}
                                      <div className="relative font-normal w-full sm:w-auto">
                                        <input
                                          type="text"
                                          className="w-full sm:w-auto p-2 pl-6 text-xs border rounded-xl focus:ring-2 focus:ring-indigo-500"
                                          placeholder="Search Files"
                                          value={searchQuery}
                                          onBlur={handleBlur}
                                          onChange={(e) => {
                                            setCurrentPage(1);
                                            setSearchQuery(e.target.value);
                                          }}
                                        />
                                        <span className="absolute left-2 top-3 text-gray-500">
                                          <img
                                            src="/search-normal.svg"
                                            alt="Search Icon"
                                            className="mr-2"
                                          />
                                        </span>
                                      </div>

                                      {/* Select All Button */}
                                      <div className="flex items-center text-sm pl-2 w-full sm:w-auto">
                                        <input
                                          type="checkbox"
                                          id="selectUser"
                                          className="custom-checkbox h-3 w-3 mr-2"
                                        />
                                        <span className="text-[#888888]">
                                          Select All
                                        </span>
                                      </div>

                                      {/* Remove Button */}
                                      <div className="w-full sm:w-auto text-xs">
                                        <button className="w-full sm:w-auto border bg-white text-black font-medium border-gray-300 h-8 rounded-xl text-sm px-4 flex justify-center sm:justify-between items-center focus:outline-none">
                                          <div className="flex items-center">
                                            <img
                                              src="/trash.svg"
                                              alt="Remove Icon"
                                              className="h-3 w-3 mr-2"
                                            />
                                            Remove
                                          </div>
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-2 gap-4">
                                    {documents.map((doc) => (
                                      <div
                                        key={doc.id}
                                        className="p-4 w-full rounded-md bg-[#F9F9F9] relative"
                                      >
                                        {/* Checkbox */}
                                        <div className="absolute top-2 left-2">
                                          <input
                                            type="checkbox"
                                            id="selectUser"
                                            className="custom-checkbox h-2 w-2 mr-2"
                                          />
                                        </div>

                                        {/* Delete Icon */}
                                        <button
                                          onClick={() =>
                                            console.log(`Delete ${doc.name}`)
                                          }
                                          className="absolute top-2 right-2 p-2"
                                        >
                                          <img
                                            src="/trash.svg"
                                            alt="Delete Icon"
                                            className="h-4 w-4"
                                          />
                                        </button>

                                        {/* Document Details */}
                                        <div className="flex items-center">
                                          <div className="h-10 w-10 flex-shrink-0">
                                            <img
                                              src={doc.icon}
                                              alt="Document Icon"
                                              className="h-10 w-10"
                                            />
                                          </div>
                                          <div className="ml-4">
                                            <p className="text-sm">
                                              <span className="font-medium">
                                                {doc.name}
                                              </span>
                                            </p>
                                            <p className="text-xs mt-1 text-black">
                                              {doc.date}
                                            </p>
                                            <p className="text-xs font-semibold text-black">
                                              {doc.size}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex justify-between font-medium text-sm items-center mt-6">
                                  <button
                                    onClick={toggleAddTemplatePopup}
                                    className="px-4 py-2 rounded-full bg-white text-black border-2 border-black "
                                  >
                                    Back
                                  </button>
                                  <button className="px-8 py-2 rounded-full bg-black text-white">
                                    Select (2)
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex text-sm pl-2 items-center">
                        <input
                          type="checkbox"
                          id="selectUser"
                          className="custom-checkbox h-3 w-3 mr-2"
                        />{" "}
                        <span>Include e-Signatures</span>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex justify-between font-medium text-sm items-center mt-6">
                      <button
                        onClick={toggleSendMessagePopup}
                        className="px-4 py-2 rounded-full bg-white text-black border-2 border-black "
                      >
                        Save Draft
                      </button>
                      <button className="px-8 py-2 rounded-full bg-black text-white">
                        Send
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Remove Button */}
              <div className="w-full sm:w-auto">
                <button
                  onClick={(e) => removeUsers(e)}
                  className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                >
                  <div className="flex items-center">
                    <img
                      src="/trash.svg"
                      alt="Remove Icon"
                      className="h-5 w-5 mr-2"
                    />
                    Remove
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div>
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                  <tr className="mb-4">
                    <th
                      key="1"
                      className="cursor-pointer font-medium px-4 py-2 border rounded-l text-left"
                    >
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          id="selectUser"
                          checked={selectAll} // Bind to Select All state
                          onChange={toggleSelectAll} // Handle toggle
                          className="custom-checkbox h-3 w-3 mr-2"
                        />{" "}
                        <span>All</span>
                      </div>
                    </th>

                    {/* Dynamic Headers */}
                    {reviewHeaders.map((header) => (
                      <th
                        onClick={() => handleSort(header.key)}
                        key={header.label}
                        className="cursor-pointer font-medium px-4 py-2  border text-left"
                      >
                        <div className="flex items-center justify-between w-full">
                          <span>{header.label}</span>
                          {header.label !== "" && (
                            <img
                              src="/sort.svg"
                              alt="Sort Icon"
                              className="w-4 h-4 ml-auto"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                    <th className="cursor-pointer font-medium px-4 py-2  border text-left">
                      <div className="flex items-center justify-between w-full">
                        <span></span>
                      </div>
                    </th>
                    {/* Star Column */}
                    <th className="text-center border py-4 rounded-r">
                      <img
                        src="/unfilled-star.svg"
                        alt="Star Icon"
                        className="w-5 h-5 ml-4 mr-10"
                      />
                    </th>
                    <th className="text-center border py-4 rounded-r">
                      <img
                        src="/three-dots-grey.svg"
                        alt="Star Icon"
                        className="w-5 h-5 ml-4 mr-10"
                      />
                    </th>
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm mt-4 font-medium text-black">
                    {customers.map((customer) => (
                      <tr className="px-6 py-2 bg-[#F9F9F9]">
                        <td className="px-6 rounded-l border-r-0 border py-2">
                          <input
                            type="checkbox"
                            id="selectUser"
                            checked={selectedCustomers.includes(customer.id)} // Check if selected
                            onChange={() => toggleTableSelection(customer.id)}
                            className="custom-checkbox h-4 w-4 rounded"
                          />
                        </td>
                        <td
                          onClick={() => {
                            let redirectState = {
                              path: `/advisor-details/${customer.id}/${customer.previous_user_id}`,
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            };
                            sessionStorage.setItem(
                              "redirectAfterLogin",
                              JSON.stringify(redirectState)
                            );
                            navigate(
                              `/advisor-details/${customer.id}/${customer.previous_user_id}`,
                              {
                                state: {
                                  from: location.pathname,
                                  historyStack: [
                                    ...(location.state?.historyStack || []),
                                    location.pathname,
                                  ],
                                  customerId: customer.id,
                                },
                              }
                            );
                          }}
                          className=" cursor-pointer px-4 py-4 border-b border-t text-left min-w-[200px] max-w-[400px] font-medium flex items-center space-x-2"
                        >
                          <img
                            src="/avatar.svg"
                            className="w-8 h-8 rounded-full"
                          />
                          <span className="text-left">
                            {customer.type == "Corporate"
                              ? customer.company_name
                              : customer.first_name + " " + customer.last_name}
                          </span>
                        </td>
                        <td className="px-4 w-20 border-b border-t py-2">
                          {customer.status}
                        </td>

                        {/* Dropdown Button */}
                        <td className="px-4 py-2 w-40 border-b border-t relative">
                          {customer.client_id}
                        </td>

                        <td className="px-4 w-20 py-2 border-b border-t text-ellipsis  overflow-hidden whitespace-nowrap">
                          {customer.type}
                        </td>

                        <td className="px-4 py-2 text-left border-b border-t">
                          {customer.cash_accounts}
                        </td>

                        <td className="px-4 py-2 text-center border-b border-t">
                          {customer.portfolio}
                        </td>

                        <td className="px-4 py-2 text-center border-b border-t">
                          {customer.credit}
                        </td>

                        <td className="px-4 py-2 text-ellipsis overflow-hidden border-b border-t">
                          <div className="px-2">
                            <span>{customer.location}</span>
                          </div>
                          <div className="px-2">
                            <span className="text-[#75E380]">Low</span>
                          </div>
                        </td>
                        <td className="px-4 py-2 border-b border-t  text-ellipsis overflow-hidden whitespace-nowrap">
                          <div className="flex items-center space-x-2">
                            <img
                              src="/clock.svg"
                              alt="Time Icon"
                              className="h-4 w-4"
                            />
                            <span className="rounded-xl">
                              {formatDateTime(customer.created_at)}
                            </span>
                          </div>
                        </td>
                        <td
                          onClick={() => {
                            let redirectState = {
                              path: "/review-kyc",
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            };
                            sessionStorage.setItem(
                              "redirectAfterLogin",
                              JSON.stringify(redirectState)
                            );
                            navigate("/review-kyc", {
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            });
                          }}
                          className="px-4 py-2 border-b border-t  text-ellipsis  overflow-hidden whitespace-nowrap"
                        >
                          <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                            Review Application
                          </span>
                        </td>
                        <td className="text-center rounded-r  border-b border-t">
                          {selectedCustomers.includes(customer.id) && (
                            <img
                              src="/filled-star.svg"
                              alt="Star Icon"
                              className="h-4 w-4 ml-2 ml-2 mb-1"
                            />
                          )}
                          {!selectedCustomers.includes(customer.id) && (
                            <img
                              src="/unfilled-star.svg"
                              alt="Star Icon"
                              className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                            />
                          )}
                        </td>
                        <td
                          onClick={(e) => {
                            setSelectedCustomers(
                              (prevSelected) =>
                                prevSelected.includes(customer.id)
                                  ? prevSelected.filter(
                                      (id) => id !== customer.id
                                    ) // Remove if already selected
                                  : [...prevSelected, customer.id] // Add if not selected
                            );
                            removeUsers(e);
                          }}
                          className="text-center w-40 rounded-r border-r border-b border-t"
                        >
                          <img
                            src="/trash.svg"
                            alt="Star Icon"
                            className="h-3 w-3  mx-auto"
                          />
                        </td>
                      </tr>
                    ))}{" "}
                  </tbody>
                )}
              </table>
            </div>

            <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
              {/* Entries Info Section */}
              <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                Showing {showRecords * (currentPage - 1) + 1} to{" "}
                {currentPage === totalPages || totalPages == 0
                  ? totalCount
                  : Math.max(showRecords * currentPage, customers.length)}{" "}
                of {totalCount} entries
              </div>

              {/* Pagination Section */}
              <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                {/* Previous Button */}
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Prev
                </button>

                {/* Page Buttons */}
                {Array.from({ length: Math.min(totalPages, 5) }).map(
                  (_, index) => {
                    const startPage = Math.max(
                      1,
                      Math.min(totalPages - 4, currentPage - 2)
                    );
                    const page = startPage + index;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded ${
                          currentPage === page
                            ? "bg-black text-white"
                            : "bg-white border border-gray-300 text-black"
                        }`}
                      >
                        {page}
                      </button>
                    );
                  }
                )}

                {/* Next Button */}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvisorList;
